/**
 * TASK STATUS ICON — icona singola che rappresenta visualmente il
 * TaskStatus. Riusa CSS custom properties della palette
 * (--color-text-light/info/warning/error) per il colore: niente hex
 * inline. Le classi `task-status-icon--{status}` vivono in
 * _components.scss.
 *
 * SYNC: la mappa qui sotto va tenuta allineata all'union TaskStatus
 * (taskTypes.ts) — l'esaustività è verificata a compile-time dal
 * Record<TaskStatus, ...>.
 */

import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import ScheduleIcon from '@mui/icons-material/Schedule';
import TodayIcon from '@mui/icons-material/Today';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { TaskStatus } from './taskTypes';

const ICON_BY_STATUS: Record<TaskStatus, React.ComponentType<SvgIconProps>> = {
  todo: RadioButtonUncheckedIcon,
  imminent: ScheduleIcon,
  expiring_today: TodayIcon,
  expired: ErrorOutlineIcon,
  completed: CheckCircleIcon,
};

interface TaskStatusIconProps {
  status: TaskStatus;
  className?: string;
}

export function TaskStatusIcon({ status, className }: TaskStatusIconProps) {
  const Icon = ICON_BY_STATUS[status];
  const cls = ['task-status-icon', `task-status-icon--${status}`, className].filter(Boolean).join(' ');
  return <Icon fontSize="small" className={cls} />;
}
